module.exports = __webpack_public_path__ + "images/Ubuntu-Medium_785d8031758d1fac400213600066aee6.ttf";